import React, { forwardRef, useCallback, useImperativeHandle } from "react";
import { InputGroup } from 'react-bootstrap';

import '../InitialForm/InitialFormStyleSheet.css';

function RadioButton(props, ref) {
  let selectedOption = null;
  const onOptionChange = (option) => {
    selectedOption = option;
  }
  const value = useCallback(() => {
    if (!selectedOption) {
      return {};
    }
    let aValue = {};
    aValue[props.item.label] = selectedOption;
    return aValue;
  }, [props.item.label, selectedOption]);

  const validate = useCallback(() => {
    let formItemDetails = props.item || {};
    let isRequired = formItemDetails.required || formItemDetails.primaryField;
    return !(isRequired && !selectedOption);
  }, [props.item, selectedOption])

  const validationErrorMessage = useCallback(() => {
    return "Please select " + props.item.label.toLowerCase() + ".";
  }, [props.item.label])

  useImperativeHandle(ref, () => {
    return {
      value() {
        return value();
      },
      validate() {
        return validate();
      },
      validationErrorMessage() {
        return validationErrorMessage()
      }
    };
  }, [validate, validationErrorMessage, value]);

  return (
    <div className="s360-initial-form-radiobutton-container" style={props.config?.customDesign?.initialFormRadioButtonContainer} ref={ref}>
      <fieldset style={{ "border": "1px solid silver", "margin": "6px -1px","padding": ".35em .625em .75em", "borderRadius": "5px" }}>
        <legend
          style={{
            "display": "block",
            "width": "auto",
            "padding": "2px",
            "marginBottom": "0",
            "fontSize": "13px",
            "lineHeight": "inherit",
            "color": "#333",
            "border": "0",
            "borderBottom": "none"
          }}
        >
          {props.item.label}
        </legend>
        <div className="s360-initial-form-radiobutton-option" style={props.config?.customDesign?.initialFormRadioButtonOption}>
          <InputGroup>
            <InputGroup.Prepend>
              {props && props.item.options && props.item.options.map(eachOption => {
                return (
                  <>
                    <InputGroup.Radio
                      name={props.item.label}
                      value={eachOption}
                      onChange={(e) => {
                        e.target.style.backgroundColor = "red";
                        e.target.style.borderColor = "red";
                        onOptionChange(eachOption);
                      }}
                    />
                    <span style={{ paddingLeft: "5px" }}> {eachOption}</span>
                    <br />
                  </>
                )
              })}
            </InputGroup.Prepend>
          </InputGroup>
        </div >
      </fieldset>
    </div>
  );
}

export default forwardRef(RadioButton);
